import React, { Fragment } from 'react';

// local dependencies
import { PageLevelPreloader } from 'modules/page-level-preloader';
import { OverlayMounter } from 'modules/overlay';
import { PopoverMounter } from 'modules/popover';
import { TooltipMounter } from 'modules/tooltip';

/**
 * @type {object}
 * @desc This react view provides all the global components.
 * @example
 * import { globalComponentsProvider as GlobalComponentsProvider } from 'ui/views/global/globalComponentsProvider';
 *
 * // render
 * <GlobalComponentsProvider/>
 */
export const globalComponentsProvider = () => {
    return (
        <Fragment>

            {/* popover component */}
            <PopoverMounter />

            { /* overlay component */ }
            <OverlayMounter />

            { /* page-level preloader component */ }
            <PageLevelPreloader/>

            { /* tooltip component */ }
            <TooltipMounter/>

        </Fragment>
    );
};

// set display name
globalComponentsProvider.displayName = 'globalComponentsProvider';

// set default props
globalComponentsProvider.defaultProps = {};
